import { Link } from 'react-router-dom';
import { Col, Result, Row } from 'antd';

import { Links } from 'links';

export const Page403 = () => {
  const link = <Link to={Links.Snaps}>Go To Snaps</Link>;

  return (
    <Row className='h-full' align='middle'>
      <Col xs={24}>
        <Result
          title='403'
          extra={link}
          status='403'
          subTitle='Sorry, you are not authorized for this action.'
        />
      </Col>
    </Row>
  );
};
